import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

export const Text = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-family: "DomineRegular";
  font-size: 14px;
  font-weight: 700;
  font-style: normal;
  line-height: 16px;
  border-radius: 4px;
  cursor: pointer;
  color: ${(props) => props.color};
  background: ${(props) => props.background};
`;
